/**
 * File: menuItemsUtils.ts
 * Path: apps/admin/src/modules/layout/utils/menuItemsUtils.ts
 * Description: The menu a role sees: the role's links, and Accounting > Setup
 * dropped once every books setup step is done (it then lives under
 * Settings > Books setup).
 */

import { ADMIN_PATHS, SIDEBAR_ITEMS, visibleNavItems, type AdminNavItem } from "@idk/config";
import type { Permission } from "@idk/types";

export const menuItemsFor = (can: (permission: Permission) => boolean, setupDone: boolean): AdminNavItem[] => {
  const items = visibleNavItems(SIDEBAR_ITEMS, can);
  if (!setupDone) return items;
  return items.map((item) =>
    item.children ? { ...item, children: item.children.filter((child) => child.href !== ADMIN_PATHS.accounting.setup) } : item,
  );
};
